// extracted by mini-css-extract-plugin
export default {"titleSubTitleHolder":"FormHeader_titleSubTitleHolder__36Nq7","homeLinkHolder":"FormHeader_homeLinkHolder__mPEHz"};